import React from "react";

import { getAppName } from "features/plurall";
import DeviceWarningModal from "./DeviceWarningModal";

export default function InternetExplorerNotSupportedModal() {
  return (
    <DeviceWarningModal
      topMessage={`Sorry you can’t use ${getAppName()} on Internet Explorer yet. Please use a newer browser like Chrome, Firefox or Safari.`}
      bottomMessage="Why..? Microsoft don’t update Internet Explorer anymore which means you would miss out on our best features."
    />
  );
}
